var map = {
  "./DoorDash.svg": "2755",
  "./TravelPerk.svg": "42907",
  "./amazon-business.svg": "79182",
  "./americanairlines.svg": "55792",
  "./approved.svg": "83246",
  "./arrow-move-down.svg": "79737",
  "./arrow-move-up.svg": "7670",
  "./audit-flag.svg": "24659",
  "./audit-ok.svg": "25635",
  "./audit-violation.svg": "22242",
  "./check-blue.svg": "52362",
  "./check-gray.svg": "35399",
  "./close.svg": "56569",
  "./collapse-down.svg": "61547",
  "./collapse-left.svg": "31180",
  "./collapse-right.svg": "16947",
  "./comment.svg": "32082",
  "./config-steps-category.svg": "61312",
  "./config-steps-credit.svg": "85559",
  "./config-steps-department.svg": "33194",
  "./config-steps-glds.svg": "65694",
  "./config-steps-integrations.svg": "79977",
  "./config-steps-policy.svg": "51982",
  "./config-steps-settings.svg": "41871",
  "./config-steps-users.svg": "2216",
  "./credit-card-config.svg": "43445",
  "./credit-card-copy-paste.svg": "41873",
  "./credit-card-grey.svg": "47169",
  "./credit-card-sync-outline.svg": "30516",
  "./credit-card.svg": "30223",
  "./delete.svg": "69118",
  "./details.svg": "73303",
  "./dinewise.svg": "79893",
  "./disapproved.svg": "90832",
  "./edit.svg": "22595",
  "./expand.svg": "29603",
  "./filter.svg": "97357",
  "./help.svg": "40286",
  "./lightbulb-blue.svg": "11829",
  "./logomark-blue.svg": "33822",
  "./logomark-green-faded.svg": "16810",
  "./logomark-green.svg": "3087",
  "./logomarks/certify-icon.svg": "90901",
  "./logomarks/emburse-cards.svg": "40130",
  "./logomarks/emburse-pay.svg": "83549",
  "./logomarks/emburseanalytics.svg": "58072",
  "./material/account_balance_wallet-black.svg": "52665",
  "./material/add-black.svg": "49534",
  "./material/bar_chart-black.svg": "48845",
  "./material/build-gray.svg": "16899",
  "./material/card_giftcard-black.svg": "92494",
  "./material/done-gray.svg": "71113",
  "./material/exit_to_app-gray.svg": "51103",
  "./material/help_outline-gray.svg": "52315",
  "./material/home-black.svg": "24280",
  "./material/launch-gray.svg": "53786",
  "./material/list_alt-black.svg": "13885",
  "./material/people-gray.svg": "98354",
  "./material/person-gray.svg": "1188",
  "./material/receipt-black.svg": "93967",
  "./material/remove.svg": "62727",
  "./material/search-gray.svg": "54065",
  "./material/settings-gray.svg": "96924",
  "./material/vertical_align_bottom.svg": "67083",
  "./new-window.svg": "18336",
  "./quicklinks-blue.svg": "14324",
  "./receipt.svg": "43401",
  "./rotate-left.svg": "24248",
  "./rotate-right.svg": "34247",
  "./save.svg": "17232",
  "./suitcase.svg": "24484",
  "./training-blue.svg": "67306",
  "./user.svg": "14838",
  "./zoom-in.svg": "97418",
  "./zoom-out.svg": "34813"
};


function __rspack_async_context(req) {
  return __rspack_async_context_resolve(req).then(__webpack_require__);
}
function __rspack_async_context_resolve(req) {
  // Here Promise.resolve().then() is used instead of new Promise() to prevent
  // uncaught exception popping up in devtools
  return Promise.resolve().then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.resolve = __rspack_async_context_resolve;
__rspack_async_context.id = 7765;
module.exports = __rspack_async_context;
